import { useConfig } from "../state";
import { HitLink } from "./HitLink";

const attributes = [
  "area",
  "zone_1",
  "zone_2",
  "zoning_single",
  "land_cover",
  "nnn",
  "natura_2000",
  "arch_monuments",
];
const KeyVal = ({ k, children }) =>
  !children ? null : (
    <div className="p-0.5">
      <span className="w-32 inline-block italic">{k}</span> {children}
    </div>
  );
export const ListHit = ({ hit }) => {
  const config = useConfig();
  return (
    <HitLink hit={hit}>
      <div className="w-32 lg:w-52 flex-item">
        <img
          src={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170`}
          srcSet={`${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=170&height=170 1x, ${config.referenceUrl}/api/image/cadastre?c=${hit.geometry}&width=340&height=340 2x`}
          className="w-full border-2 border-solid border-gray-300 rounded-lg"
          alt={hit.name}
        />
      </div>
      <div className="flex-item pl-2">
        <KeyVal k="Adres">{hit.addresses?.[0]}</KeyVal>
        <KeyVal k="Kadastraal">{hit.name}</KeyVal>
        {attributes.map((key) => (
          <KeyVal key={key} k={config.facetMapping[key].split(" ")[0]}>
            {hit[key]}
          </KeyVal>
        ))}
      </div>
    </HitLink>
  );
};
